import _get from 'lodash/get'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration, FlowValues } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const liability_previously_owned = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('previous_insurance_in_last_5y')]:
        BaseSchema_LiabilityV1GetsafeDe.shape.previous_insurance_in_last_5y,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_liabilityNxt:steps.liability.previously_owned.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_liabilityNxt:steps.liability.previously_owned.infoText',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    onSubmit: {
      type: 'simpleHook',
      inputs: [params.helperFunctions.getParamPath('previous_insurance_in_last_5y')],
      outputs: [
        params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
        params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      ],
      callback: (formValues: FlowValues) => {
        const prevInsurance = _get(
          formValues,
          params.helperFunctions.getParamPath('previous_insurance_in_last_5y')
        )

        if (prevInsurance === false) {
          return {
            formValues: {
              [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]: 0,
              [params.helperFunctions.getParamPath('cancelled_by_previous_insurer')]: false,
            },
          }
        }
      },
    },
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      valueToStepName: {
        true: 'liability_damages',
        false: 'liability_drone',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default liability_previously_owned
